module.exports = __webpack_public_path__ + "img/vector.45a837e3.png";